/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response for the cross-service ``external_session_id`` resolver endpoint.
 *
 * Used by new-api's Phase B1 backfill to map a legacy ``universal_clinic_id``
 * value back to its canonical ``ClinicRequest.id``. See TBD-364.
 */
export interface ResolveExternalSessionResponse {
  /** The canonical ``ClinicRequest.id`` the external_session_id maps to. */
  clinic_request_id: string;
  /** Which shape the input matched: ``canonical`` (already ClinicRequest.id), ``curai_conv`` (legacy Curai Conversation.id), or ``nori_conv`` (legacy Nori Conversation.id). */
  legacy_shape: string;
}
